//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
import drawLercv2 from './gago-render/draw_lerc';
import drawLerc3d from './gago-render/draw_lerc_3d';
import drawLercTerrain from './gago-render/draw_lerc-terrain';
import drawLercOverlay from './gago-render/draw_lerc_overlay';
import drawLercGrid from './gago-render/draw_lerc-grid';
import drawLercCompare from './gago-render/draw_lerc-compare';

// setDraw
const gagoDraws = [
    {
        name: 'lercv2',
        draw: drawLercv2,
    },
    // {
    //     name: 'lerc3D',
    //     draw: require('./gago-render/draw_lerc3D'),
    // },
    {
        name: 'lerc-3d',
        draw: drawLerc3d,
    },
    {
        name: 'lerc-terrain',
        draw: drawLercTerrain,
    },
    {
        name: 'lerc-overlay',
        draw: drawLercOverlay,
    },
    {
        name: 'lerc-grid',
        draw: drawLercGrid,
    },
    {
        name: 'lerc-compare',
        draw: drawLercCompare,
    },
];

export const modifyDraws = function (setDraw) {
    gagoDraws.forEach(({ name, draw }) => {
        setDraw(name, draw);
    });
};

